import React from 'react'
import TendersTable from './components/TendersTable'
import { useTranslation } from 'react-i18next'

const Tenders = () => {
  const { t } = useTranslation()

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold mb-0">{t('Procurement_tenders_tenders_label')}</h1>
      </div>
      <TendersTable />
    </div>
  )
}

export default Tenders
